import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Alert,
  CircularProgress,
  Chip,
} from "@mui/material";
import {
  Save as SaveIcon,
  ArrowBack as ArrowBackIcon,
  Preview as PreviewIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { fetchCategories, createPost } from "../MockApi";
import axios from "axios";

const CreatePost = () => {
  const navigate = useNavigate();
  // const isAuthenticated = localStorage.getItem("isAuthenticated");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("isAuthenticated")?.toLowerCase() === "true";

    if (query) localStorage.setItem("isAuthenticated", "true");

    const local = localStorage.getItem("isAuthenticated") === "true";
    setIsAuthenticated(local);
  }, [location.search]);

  const raw = localStorage.getItem("localuser-storage");
  const userdata = raw ? JSON.parse(raw) : null;
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");

  const userId = userdata?.state?.localuser?.userid;
  const baseUrl = process.env.REACT_APP_HOST_API;
  const [formData, setFormData] = useState({
    userId: userId || "",
    title: "",
    categoryId: "",
    body: "",
  });
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [maxImages, setMaxImages] = useState();
  const [fileSize, setMaxFileSize] = useState();
  const MAX_FILE_SIZE_MB = fileSize
    ? (fileSize / (1024 * 1024)).toFixed(1)
    : null;
  const MAX_FILE_SIZE_BYTES = fileSize;

  // React Quill modules configuration
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link"],
      // ['link', 'image'],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    "image",
  ];
  const MaxPictures = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/users/meta-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const settings = response?.data?.data?.[0];
      setMaxImages(settings?.maxImages);
      setMaxFileSize(settings?.maxFileSize);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    MaxPictures();
  }, []);

  useEffect(() => {
    const loadCategories = async () => {
      setCategoriesLoading(true);

      try {
        const response = await axios.get(
          `${baseUrl}/forum/categories-aggregation`
        );
        const loadedCategories = response?.data?.data || [];
        let categoriesToUse = loadedCategories;
        const totalCategoriesCount = 10;
        if (loadedCategories.length < totalCategoriesCount) {
          const allResponse = await axios.get(`${baseUrl}/forum/categories`);
          categoriesToUse = allResponse?.data?.data || [];
        }
        setCategories(categoriesToUse);
      } catch (error) {
        console.error("Failed to load categories:", error);
      } finally {
        setCategoriesLoading(false);
      }
    };
    loadCategories();
  }, []);

  const handleImageChange = (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (images.length + files.length > 3) {
      setImageError("You can only upload a maximum of 3 images.");
      return;
    }
    for (const file of files) {
      if (file.size > MAX_FILE_SIZE_BYTES) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        debugger;
        setImageError(
          `File "${file.name}" is too large (${fileSizeMB} MB). Maximum allowed size is ${MAX_FILE_SIZE_MB} MB.`
        );
        return;
      }
    }

    setImages((prevImages) => [...prevImages, ...files]);
  };

  const handleRemoveImage = (indexToRemove) => {
    setImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (error) setError(null);
  };

  const validateForm = () => {
    if (!formData.title.trim()) {
      setError("Please enter a post title.");
      return false;
    }

    if (!formData.categoryId) {
      setError("Please select a category.");
      return false;
    }

    if (!formData.body.trim() || formData.body === "<p><br></p>") {
      setError("Please enter post content.");
      return false;
    }

    return true;
  };
  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const postData = new FormData();

    postData.append("userId", formData.userId);
    postData.append("title", formData.title.trim());
    postData.append("categoryId", formData.categoryId);
    postData.append("query_text", formData.body);

    images.forEach((imageFile) => {
      postData.append("images", imageFile);
    });

    try {
      setLoading(true);
      setError(null);

      const response = await axios.post(`${baseUrl}/forum/publish`, postData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSuccess(true);
      const post = response?.data?.Post;
      if (response && response?.data && response?.data?.Post._id) {
        navigate(`/ForumsCategory/post/${response?.data?.Post?._id}`, {
          state: { post, message: "Post Created Successfully" },
        });
      } else {
        navigate("/");
      }
    } catch (err) {
      if (err.response && err.response.status === 413) {
        setError(
          "The total size of the uploaded images is too large. Please reduce the number of images or use smaller ones."
        );
      } else {
        setError("Failed to create post. Please try again.");
        console.error("Create post error:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handlePreview = () => {
    if (!formData.title || !formData.body) {
      setError("Please fill in the title and content to preview.");
      return;
    }

    // In a real app, this would open a preview modal
    alert("Preview functionality would be implemented here.");
  };

  // Don't render if not authenticated (will redirect)
  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {/* Custom CSS for ReactQuill white styling */}
      <style jsx global>{`
        /* Toolbar styling */
        .ql-toolbar {
          border-top: 1px solid #ccc !important;
          border-left: 1px solid #ccc !important;
          border-right: 1px solid #ccc !important;
        }

        /* Toolbar buttons and icons */
        .ql-toolbar .ql-stroke {
          fill: none !important;
          stroke: white !important;
        }

        .ql-toolbar .ql-fill {
          fill: white !important;
          stroke: none !important;
        }

        .ql-toolbar .ql-even {
          fill-rule: evenodd !important;
          fill: white !important;
        }

        .ql-toolbar .ql-color-label {
          fill: white !important;
          stroke: white !important;
        }

        /* Dropdown arrows */
        .ql-toolbar .ql-picker-label {
          color: white !important;
        }

        .ql-toolbar .ql-picker-label::before {
          color: white !important;
        }

        /* Active state for toolbar buttons */
        .ql-toolbar button:hover,
        .ql-toolbar button:focus,
        .ql-toolbar button.ql-active {
          color: white !important;
        }

        .ql-toolbar button:hover .ql-stroke,
        .ql-toolbar button:focus .ql-stroke,
        .ql-toolbar button.ql-active .ql-stroke {
          stroke: #06c !important;
        }

        .ql-toolbar button:hover .ql-fill,
        .ql-toolbar button:focus .ql-fill,
        .ql-toolbar button.ql-active .ql-fill {
          fill: #06c !important;
        }

        /* Placeholder text styling */
        .ql-editor.ql-blank::before {
          color: white !important;
          opacity: 0.7;
        }

        /* Editor content styling */
        .ql-editor {
          color: white !important;
        }

        /* Dropdown menus */
        .ql-picker-options {
          background-color: #333 !important;
          border: 1px solid #555 !important;
        }

        .ql-picker-item {
          color: white !important;
        }

        .ql-picker-item:hover {
          background-color: #555 !important;
        }

        /* Snow theme container */
        .ql-container.ql-snow {
          border-bottom: 1px solid #ccc !important;
          border-left: 1px solid #ccc !important;
          border-right: 1px solid #ccc !important;
        }
      `}</style>

      <Container maxWidth="xxxl" sx={{ px: { xs: 1, sm: 2 } }}>
        {/* Header */}
        <Paper
          elevation={1}
          sx={{
            p: 3,
            mb: 3,
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Chip
              icon={<ArrowBackIcon />}
              label="Back"
              clickable
              onClick={handleBackClick}
              variant="outlined"
              sx={{ mr: 2 }}
            />
          </Box>

          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            Create New Post
          </Typography>

          <Typography variant="body1" color="text.secondary">
            Share your thoughts with the community
          </Typography>
        </Paper>

        {/* Success Alert */}
        {/* {success && (
          <Alert severity="success" sx={{ mb: 3 }}>
            Post created successfully! Redirecting...
          </Alert>
        )} */}

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Form */}
        <Paper
          elevation={1}
          sx={{
            p: 3,
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            {/* Title Field */}
            <TextField
              fullWidth
              label="Post Title"
              variant="outlined"
              value={formData.title}
              onChange={(e) => handleInputChange("title", e.target.value)}
              placeholder="Enter an engaging title for your post..."
              sx={{
                mb: 3,
              }}
              disabled={loading}
            />

            {/* Category Selection */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={formData.categoryId}
                label="Category"
                onChange={(e) =>
                  handleInputChange("categoryId", e.target.value)
                }
                disabled={loading || categoriesLoading}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: 3,
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                  },
                }}
              >
                {categoriesLoading ? (
                  <MenuItem disabled>Loading categories...</MenuItem>
                ) : (
                  categories.map((category) => (
                    <MenuItem
                      key={category._id}
                      value={category._id}
                      sx={{ borderRadius: 5 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            bgcolor: category.color,
                            mr: 1.5,
                          }}
                        />
                        {category.name}
                      </Box>
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>

            {/* Rich Text Editor */}
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ fontWeight: "medium" }}
              >
                Post Content
              </Typography>
              <Box
                sx={{
                  "& .ql-container": {
                    minHeight: "200px",
                    fontSize: "16px",
                  },
                  "& .ql-editor": {
                    minHeight: "200px",
                  },
                }}
              >
                <ReactQuill
                  theme="snow"
                  value={formData.body}
                  onChange={(value) => handleInputChange("body", value)}
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder="Write your post content here..."
                  readOnly={loading}
                />
              </Box>
            </Box>

            {/* Image Upload Section */}
            <Box
              sx={{ mb: 3, p: 2, border: "1px dashed grey", borderRadius: 5 }}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{ fontWeight: "medium" }}
              >
                {`Upload Images (Max ${maxImages} only PNG, JPG, JPEG)`}
              </Typography>
              <Button
                variant="outlined"
                component="label"
                disabled={loading || images.length >= 3}
              >
                {`Select Images (${MAX_FILE_SIZE_MB}MB each max)`}
                <input
                  type="file"
                  hidden
                  multiple
                  accept="image/png, image/jpeg, image/gif"
                  onChange={handleImageChange}
                />
              </Button>
              {imageError && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {imageError}
                </Alert>
              )}

              {/* Image Previews */}
              {images.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
                  {images.map((file, index) => (
                    <Box key={index} sx={{ position: "relative" }}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt="preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                      <Chip
                        label="X"
                        size="small"
                        color="error"
                        onClick={() => handleRemoveImage(index)}
                        sx={{
                          position: "absolute",
                          top: -5,
                          right: -5,
                          cursor: "pointer",
                          height: "20px",
                          width: "20px",
                          "& .MuiChip-label": { padding: 0 },
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                type="submit"
                variant="contained"
                startIcon={
                  loading ? <CircularProgress size={20} /> : <SaveIcon />
                }
                disabled={loading}
                size="large"
                sx={{ borderRadius: 3 }}
              >
                {loading ? "Creating..." : "Create Post"}
              </Button>
            </Box>
          </Box>
        </Paper>

        {/* Help Text */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mt: 2,
            bgcolor: "background.default",
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            <strong>Tips for a great post:</strong>
            <br />
            • Use a clear and descriptive title
            <br />
            • Choose the most relevant category
            <br />
            • Format your content with headings and lists for better readability
            <br />• Be respectful and constructive in your discussions
          </Typography>
        </Paper>
      </Container>
    </>
  );
};

export default CreatePost;
